import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  COLORS,
  HEADING_TYPE,
  BUTTON_SIZE,
  BUTTON_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  PANELS,
} from '@helpers/constants'
import { SchoolClassCardStyle } from './style'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import Icon from '@components/Icon'
import Divider from '@components/Divider'
import { useCurrentUser } from '@hooks/useCurrentUser'
import { useBooksWithRelatedSchoolGroups } from '@hooks/useBooksWithRelatedSchoolGroups'
import { AppContext } from '@state/context'
import { openPanel } from '@state/actions/panelsActions'
import { useConfirmRemoveSchoolClass } from '@hooks/useConfirmRemoveSchoolClass'

const SchoolClassCard = (props) => {
  const { schoolClass } = props
  const [, dispatch] = useContext(AppContext)
  const { id, isPrivate, name, students, books } = schoolClass
  const { currentUser } = useCurrentUser()
  const { booksWithRelatedSchoolGroups, isLoading } = useBooksWithRelatedSchoolGroups(id)
  const { confirmRemoveSchoolClass } = useConfirmRemoveSchoolClass(schoolClass)

  return (
    <div className={SchoolClassCardStyle.container}>
      <div>
        <Heading
          size={TEXT_SIZES.LARGE}
          headingLevel={HEADING_TYPE.H2}
          color={COLORS.WHITE.TEXT}
        >
          {name}
        </Heading>
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <div className={'flex justify-between items-end'}>
        <div>
          <div className={'flex items-center text-white'}>
            <Icon icon={'Classes'} />
            <Text
              size={TEXT_SIZES.XXSMALL}
              color={'text-white'}
              extraClasses={'pl-2'}
            >
              Elever: {students.length}
            </Text>
          </div>

          <div className={'flex items-center text-white'}>
            <Icon icon={'Book'} />
            <Text
              size={TEXT_SIZES.XXSMALL}
              color={'text-white'}
              extraClasses={'pl-2'}
            >
              Delade böcker: {books.length}
            </Text>
          </div>
        </div>

        <div className={'flex'}>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.MEDIUM}
            to={`/klass/${id}`}
            margin
          >
            Visa klass
          </Button>

          <Button
            type={BUTTON_TYPE.DARK_GREY}
            size={BUTTON_SIZE.ICON_CIRCLE}
            disabled={isLoading}
            handleClick={
              isPrivate && currentUser?.hasValidPubAgreement
                ? booksWithRelatedSchoolGroups?.length > 0
                  ? () => dispatch(openPanel(PANELS.MIGRATE_MY_SCHOOL_CLASS))
                  : () => dispatch(openPanel(PANELS.DELETE_MY_SCHOOL_CLASS))
                : confirmRemoveSchoolClass
            }
            icon={'Exit'}
          />
        </div>
      </div>
    </div>
  )
}

SchoolClassCard.propTypes = {
  schoolClass: PropTypes.object,
  size: PropTypes.string,
}

export default SchoolClassCard
